var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.track.expanded) ? _c('div', {
    staticClass: "column col-fixed",
    attrs: {
      "id": "player"
    }
  }, [_c('progress-bar', {
    attrs: {
      "soundcloud": _vm.soundcloud,
      "track": _vm.track
    }
  }), _vm._v(" "), _c('player-controls', {
    attrs: {
      "soundcloud": _vm.soundcloud
    }
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a0b7822","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListenPage/SoundcloudPlayer.vue
// module id = f+5w
// module chunks = 1